import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Text } from '@rtkwlf/fenrir-react';
import { faTrash } from '@rtkwlf/pro-solid-svg-icons/faTrash';
import type { ScheduleRow } from '@rtkwlf/rendall';
import { useTranslation } from 'react-i18next';

import {
  Appearances,
  ConfirmationDialog,
} from '@packages/components/confirmation-dialog/confirmation-dialog';

import { useEnhancedScannerDetails } from '../../../../../../../../../../hooks/use-enhanced-scanner-details/use-enhanced-scanner-details';

import { useDeleteIvaScheduleWrapper } from './use-delete-iva-schedule-wrapper';
interface DeleteScheduleProps {
  scanScheduleRow: ScheduleRow;
}

export const DeleteScheduleButton: React.FC<DeleteScheduleProps> = ({
  scanScheduleRow,
}) => {
  const { t } = useTranslation('telemetryScannerConfig');
  const { id: scheduleId, scannerId } = scanScheduleRow;

  const { data: scannerDetails } = useEnhancedScannerDetails(scannerId);

  const { mutate: deleteSchedule } = useDeleteIvaScheduleWrapper(scannerId);

  const handleDeleteSchedule = () => {
    deleteSchedule([
      {
        scannerId,
        scheduleIds: [scheduleId],
      },
    ]);
  };

  return (
    <ConfirmationDialog
      trigger={
        <Button
          iconLeft={<FontAwesomeIcon icon={faTrash} />}
          variant="tertiary"
          appearance="danger"
          isDisabled={!scannerDetails?.isConnected}
        >
          {t('actions.delete')}
        </Button>
      }
      title={t('scanningSchedule.delete.title')}
      description={
        <>
          <Text marginBottom="small">
            {t('scanningSchedule.delete.description.line1')}
          </Text>
          <Text marginBottom="medium">
            {t('scanningSchedule.delete.description.line2')}
          </Text>
        </>
      }
      actionText={t('scanningSchedule.delete.triggerText')}
      actionIcon={<FontAwesomeIcon icon={faTrash} />}
      actionAppearance={Appearances.Danger}
      actionOnClick={handleDeleteSchedule}
    />
  );
};
